// @ts-nocheck
const breakpoints = [
  '320px',
  '500px',
  '768px',
  '900px',
  '1024px',
  '1220px',
  '1440px'
];
// aliases
breakpoints.default = breakpoints[0];
breakpoints.mobile = breakpoints[1];
breakpoints.tabletSmall = breakpoints[2];
breakpoints.tablet = breakpoints[3];
breakpoints.tabletLandscape = breakpoints[4];
breakpoints.computer = breakpoints[5];
breakpoints.maxWidth = breakpoints[6];

export const base = {
  borderRadius: 5,
  space: [0, 4, 8, 16, 24, 32, 40, 48, 64, 80, 104],
  // [0, 4, 8, 16, 24, 32, 64, 128, 256, 512]
  breakpoints,
  zIndices: [-1, 10, 100, 500, 1000, 1100, 1200, 1300, 1400, 1500, 999999999],
  radii: {
    button: '5px',
    card: '5px',
    paper: '5px'
  },
  shadows: {
    0: 'none',
    10: '10px 10px 0 0 rgba(0,0,0,.3)',
    20: '20px 20px 0 0 rgba(0,0,0,.3)'
  }
};
